// ============================================================================
// MAXIMUM FLOW - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'max-flow',
  name: 'Maximum Flow',
  category: 'Graphs',
  complexity: {
    time: 'O(V * E^2)',
    space: 'O(V^2)'
  },
  description: 'Algorithm to find the maximum flow in a flow network using the Edmonds-Karp implementation of Ford-Fulkerson method. Uses BFS to find augmenting paths in the residual graph and updates flow until no more augmenting paths exist.'
};
